export enum Pages {
  HOME = "/",
  SMART_GUILD_MATCHING = "/how-matching-works",
  LOGIN = "/login",
  REGISTRATION = "/registration",
  SIGNUP = "/register",
  FORGOT_PASSWORD = "/forgot-password",
  DESIGNER_APPLICATION = "/designer-application",
  JOIN_AS_DESIGNER = "/join-as-a-designer",
  ADMIN_DASHBOARD = "/admin-dashboard",
  ADMIN_DESIGNER_APPLICATIONS = "/admin/designer-applications",
  ADMIN_HOMEOWNER_ACCOUNTS = "/admin/homeowner-accounts",
  ADMIN_MATCHES = "/admin/matches",
  ADMIN_MEMBERSHIP_PLANS = "/admin/membership-plans",
  ADMIN_FEATURE_FLAGS = "/admin/feature-flags",
  ADMIN_DMA_AVAILABILITY = "/admin/dma-availability",
  ADMIN_MESSAGES = "/admin/messages",
  ADMIN_EVENT_ATTRIBUTION = "/admin/event-attribution",
  ADMIN_USER_MANAGEMENT = "/admin/user-management",
  DASHBOARD = "/dashboard",
  PROFILE = "/profile",
  MY_ACCOUNT = "/my-account",
  SETTINGS = "/settings",
  DESIGN_COMMUNITY = "/our-design-community",
  ABOUT_DESIGN_HUB = "/about-design-hub",
  FINANCING = "/financing",
  COMING_SOON = "/coming-soon",
  CONTACT_US = "/contact-us",
  DESIGNER_MEMBERSHIP_PRICING = "/designers/membership-pricing",
  HOMEOWNER_MEMBERSHIP_PRICING = "/homeowners/membership-pricing",
  ABOUT_US_PAGE = "/about-us",
  LAUNCH = "/launch",
  EVENTS = "/events",
  TERRITORIES = "/territories",
  HOMEOWNER_LANDING = "/our-homeowners",
  HOMEOWNER_USER_LANDING = "/homeowners",
  HOMEOWNER_GUILD_GUIDES = "/homeowner-guild-guides",
  HOMEOWNER_GUILD_GUIDE_POST = "/homeowner-guild-guides/post/:slug",
  HOMEOWNER_PREFERENCE_QUIZ = "/homeowner-preference-quiz",
  PERSONALITY_QUIZ = "/personality-quiz",
  HOMEOWNER_PERSONALITY_QUIZ = "/homeowner-personality-quiz",
  DESIGNER_PERSONALITY_QUIZ = "/designer-personality-quiz",
  NOT_FOUND = "*",
  TERMS_OF_SERVICE = "/terms-of-service",
  PRIVACY_POLICY = "/privacy-policy",
  COPYRIGHT_TRADEMARK = "/copyright-and-trademark",
  MY_DESIGN_FILES = "/my-design-files",
  DESIGNER_FILES_PUBLIC = "/designer-files",
  DESIGNER_FILES_HOMEOWNER = "/homeowner-designer-files",
  DESIGNER_FILES_PROJECTS = "/designer-files/projects",
  MY_IDEA_BOOKS = "/my-idea-books",
  MY_IDEA_BOOK_DETAILS = "/my-idea-books/:ideaBookId",
  ADD_DESIGNER_FILE = "/add-designer-file",
  ADD_DESIGNER_FILE__BOARD = "/add-designer-file/design-board",
  ADD_DESIGNER_FILE__BEFORE_AFTER = "/add-designer-file/before-after",
  BEFORE_AFTER_PROJECT_MANAGER = "/before-after-project-manager",
  BEFORE_AFTER_PROJECT_MANAGER_EDIT = "/before-after-project-manager/edit/:projectId",
  BEFORE_AFTER_BLOG_VIEW = "/before-after-blog/:projectId",
  ADD_DESIGNER_FILE__PROJECT_PROFILE = "/add-designer-file/project-profile",
  MY_MATCHING_PROFILE = "/my-matching-profile",
  DESIGNER_PREMIUM_PROFILE = "/designer-profile/:designerId",
  DESIGNER_COMPATIBILITY_DETAILS = "/designer-profile/:designerId/compatibility-details",
  DESIGNER_PROJECT_DETAILS = "/designer-profile/:designerId/projects/:projectId",
  HOMEOWNER_PROFILE = "/homeowner-profile/:homeOwnerId",
  HOMEOWNER_PROFILE_SELF = "/homeowner-profile",
  COURSE = "/course",
  YOUR_HUB = "/your-hub",
  MY_BIO = "/my-bio",
  MY_PROJECTS = "/my-projects",
  MY_PROJECTS_CREATE = "/my-projects/create",
  MY_PROJECTS_EDIT = "/my-projects/:projectId/edit",
  MESSAGES = "/messages",
  MATCHES = "/matches",
  GUILD_GUIDES = "/guides",
  GUILD_GUIDE_POST = "/guides/post/:slug",
  DESIGNER_MEMBERSHIP_SELECTION = "/designer-membership-selection",
  PARTNERS = "/partners",
  REFER = "/refer",
  CAMPAIGNS = "/campaigns",
  ASSETS = "/assets",
  DESIGNER_CONFESSIONS = "/designer-confessions",
  CLIENT_FINANCING = "/client-financing",
  PROJECT_REPORTING = "/project-reporting",
  QUICK_LINKS = "/quick-links",
  DESIGNER_MEETING_SUCCESS = "/designer-application/meeting-success",
}
